function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * A mixin that forwards CSS class names to the internal overlay element
 * by setting the `overlayClass` property or `overlay-class` attribute.
 *
 * @polymerMixin
 */
export var OverlayClassMixin = function OverlayClassMixin(superclass) {
  return /*#__PURE__*/function (_superclass) {
    _inherits(OverlayClassMixinClass, _superclass);

    var _super = _createSuper(OverlayClassMixinClass);

    function OverlayClassMixinClass() {
      _classCallCheck(this, OverlayClassMixinClass);

      return _super.apply(this, arguments);
    }

    _createClass(OverlayClassMixinClass, [{
      key: "__updateOverlayClassNames",
      value:
      /** @private */
      function __updateOverlayClassNames(overlayClass, overlayElement) {
        var _this = this;

        if (!overlayElement) {
          return;
        } // Overlay is set but overlayClass is not set


        if (overlayClass === undefined) {
          return;
        }

        var classList = overlayElement.classList;

        if (!this.__initialClasses) {
          this.__initialClasses = new Set(classList);
        }

        if (Array.isArray(this.__previousClasses)) {
          // Remove old classes that no longer apply
          var classesToRemove = this.__previousClasses.filter(function (name) {
            return !_this.__initialClasses.has(name);
          });

          if (classesToRemove.length > 0) {
            classList.remove.apply(classList, _toConsumableArray(classesToRemove));
          }
        } // Add new classes based on the overlayClass


        var classesToAdd = typeof overlayClass === 'string' ? overlayClass.split(' ') : [];

        if (classesToAdd.length > 0) {
          classList.add.apply(classList, _toConsumableArray(classesToAdd));
        }

        this.__previousClasses = classesToAdd;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * A space-delimited list of CSS class names to set on the overlay element.
           * This property does not affect other CSS class names set manually via JS.
           *
           * Note, if the CSS class name was set with this property, clearing it will
           * remove it from the overlay, even if the same class name was also added
           * manually, e.g. by using `classList.add()` in the `renderer` function.
           *
           * @attr {string} overlay-class
           */
          overlayClass: {
            type: String
          },

          /**
           * An overlay element on which CSS class names are set.
           *
           * @protected
           */
          _overlayElement: {
            type: Object
          }
        };
      }
    }, {
      key: "observers",
      get: function get() {
        return ['__updateOverlayClassNames(overlayClass, _overlayElement)'];
      }
    }]);

    return OverlayClassMixinClass;
  }(superclass);
};